<!-- 生态圈 不良品分析 -->
<template>
  <h-form-page :title="h_i18n('546737fbb4766ed23f23f4febc830117')+data.title" :ction-update="changeMethod" class="analysis_one_style">
    <form-header :title="h_i18n('546737fbb4766ed23f23f4febc830117')" title-height="80px">
      <template #title></template>
      <template #body>
        <tr>
          <report-td :title="h_i18n('1b7ecd2bdbd8a1a112dead57724f06df')" colspan="4:8">{{ getData.supplyCode }}</report-td>
          <report-td :title="h_i18n('9190cc22c9ba377113bc54ac51013a0b')" colspan="4:8">{{ getData.supplyName }}</report-td>
        </tr>
        <tr>
          <report-td :title="h_i18n('f1edca9f040d256cee01ef89fa5499f0')" colspan="4:8">{{ getData.mtlNo }}</report-td>
          <report-td :title="h_i18n('901fcadda8a5683e7a83a0c811ff4382')" colspan="4:8">{{ getData.mtlName }}</report-td>
        </tr>
        <tr>
          <report-td :title="h_i18n('826d2a3c7b7c0f43ac5ca8dbf29298c1')" colspan="4:8">
            <!-- {{ getData.claimStatus }} -->
            <span v-if="getData.claimStatus === '供应商待确认'">{{ h_i18n('d1f1b35b46080de518e44a4bed0b7634') }}</span>
            <span v-else-if="getData.claimStatus === '申诉中'">{{ h_i18n('3913e7c968ca888ebceff3715077c615') }}</span>
            <span v-else-if="getData.claimStatus === '供应商已确认'">{{ h_i18n('e71b44aae6625925a4cd463d420f2fb8') }}</span>
            <span v-else-if="getData.claimStatus === '申诉成功'">{{ h_i18n('801759cbd2cd6400747a8d4edc83b42b') }}</span>
            <span v-else-if="getData.claimStatus === '申诉失败'">{{ h_i18n('6f058a99d24d36098a688e5e27a89de6') }}</span>
            <span v-else></span>
          </report-td>
          <report-td :title="h_i18n('03490f3868798323211aa633194df2c1')" colspan="4:8">{{ getData.sybName }}</report-td>
        </tr>
        <tr>
          <report-td :title="h_i18n('9318d407c5835267826c7f97ac7325f9')" colspan="4:8">{{ time(getData.receiveDate) }}</report-td>
          <report-td :title="h_i18n('f929d07215c101c695da559088e73c15')" colspan="4:8">{{ time(getData.identifyDate) }}</report-td>
        </tr>
        <tr>
          <!-- SQE节点 -->
          <report-td :title="h_i18n('3c092f8c2f02bb3868b167e04275403f')" colspan="4:8">{{ getData.sqeNode }}</report-td>
          <!-- 生态圈 -->
          <report-td :title="h_i18n('d9c8ae7c4e67140d3921659fa8664592')" colspan="4:8">{{ getData.ecosphere }}</report-td>
        </tr>
        <tr>
          <!-- 故障描述 改 故障现象 -->
          <report-td :title="h_i18n('8a1dab362ff10ef012523c02081722f2')" colspan="4:8">{{ getData.phenomenaName }}</report-td>
          <!-- 故障对象 -->
          <report-td :title="h_i18n('006770479AEDAA347F8EABC1E8B733D6')" colspan="4:8">{{ getData.problemSpot }}</report-td>
        </tr>
        <tr>
          <!-- 故障原因 -->
          <report-td :title="h_i18n('339916d7627cd80dcc1eecc698b6fd25')" colspan="4:8">{{ getData.problemReason }}</report-td>
          <!-- 失效模式 -->
          <report-td :title="h_i18n('41BEE03475B1881D33786243CAD29588')" colspan="4:8">{{ getData.failureWay }}</report-td>
        </tr>
        <tr>
          <!-- EMR记录OID -->
          <report-td :title="h_i18n('BA160FBA4D9F077779E0183BD2E41CC9')" colspan="4:20">{{ getData.oid }}</report-td>
        </tr>
      </template>
    </form-header>
    <form-area :title="data.titleList" title-height="80px">
      <template #default="{value}">
        <template v-if="data.firstType || data.secondType || data.reType">
          <form-body v-if="value===h_i18n('eba745696b4f04640b0b00ebd4d7309f')">
            <tr>
              <!-- 供应商补充OID -->
              <report-td :title="h_i18n('33239986C13032CDE38FC5FFD148BD31')" colspan="4:20" :required="getData.ecosphere === '电脑板' && !getData.oid" :question="true">
                <template #tipText>
                  <div>{{ h_i18n('7077EC6B3C8AF39B1808DF524AF4C750') }}</div>
                </template>
                <el-tooltip effect="redTip" placement="top" :disabled="false" :visible="data.chip.supplyOIDFlag" :content="data.chip.supplyOIDText">
                  <el-input v-model="postData.supplementOid" type="textarea" maxlength="1000" show-word-limit :rows="1" minlength="10" :placeholder="h_i18n('512794ECECB2B14DDDAAE6B253BC8893')"></el-input>
                </el-tooltip>
              </report-td>
            </tr>
            <tr>
              <!-- 借用分析机编 -->
              <report-td :title="h_i18n('7b9fa22a7fb8ed240412c78df089ed1b')" colspan="4:20" :question="true">
                <template #tipText>
                <div>{{ h_i18n('b79302dd8bcee65f2e104c903a3f01e8') }}</div>
              </template>
                <h-button v-if="!postData.borrowProductNum" type="warning" @click="borrowProductBtn">{{ h_i18n('2435184086774cd5ceea54a30803c1ff') }}</h-button>
                <template v-else>
                  <span style="color: #2164f5; cursor: pointer; text-overflow: ellipsis; overflow: hidden; display: inline-block"
                    @click="openBorrowProductNum()">
                    {{ postData.borrowProductNum }}
                  </span>
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  <span style="vertical-align: super;color: #e02323; cursor: pointer; display: inline-block" @click="deleteBorrowProductBtn">{{ h_i18n('2f4aaddde33c9b93c36fd2503f3d122b') }}</span>
                </template>
              </report-td>
            </tr>
            <tr>
              <report-td :title="h_i18n('104254c1b29bd1eedd493570dd7d5d9f')" colspan="4:20" required>
                <el-tooltip effect="redTip" placement="top" :disabled="false" :visible="data.analysisConclusionFlag" :content="h_i18n('ee48b55d9881b82024a9a41f67e9d854')">
                  <el-input :disabled="postData.borrowProductNum" v-model="postData.analysisConclusion" type="textarea" maxlength="500" show-word-limit :rows="3" class="td-input-style"></el-input>
                </el-tooltip>
              </report-td>
            </tr>
            <tr>
              <!-- <report-td title="缺陷类别" colspan="4:8" required>
                <el-tooltip effect="redTip" placement="top" :disabled="false" :visible="data.defectTypeFlag" content="缺陷类别不能为空">
                  <div style="position: absolute;width:40%"></div>
                </el-tooltip>
                <el-select :disabled="postData.borrowProductNum" v-model="postData.defectType" clearable filterable @change="(v)=>{!v && (postData.defectType = undefined)}">
                  <el-option v-for="item in data.defectTypeList" :key="item.id" :value="item.defectType" :label="item.defectType"></el-option>
                </el-select>
              </report-td> -->
              <!-- 缺陷类别1级 -->
              <report-td :title="h_i18n('fb3efdaa003c37ac0646cab99ca2ea26')" colspan="4:8" required>
                <el-tooltip effect="redTip" placement="top" :disabled="false" :visible="data.defectTypeFlag" :content="h_i18n('bbf0cfc7a049be0479d4dc439bf3c399')">
                  <div style="position: absolute;width:40%"></div>
                </el-tooltip>
                <el-select :disabled="postData.borrowProductNum" v-model="postData.defectType" clearable filterable @change="changeDefectType">
                  <el-option v-for="item in data.defectTypeList" :key="item.id" :value="item.defectType" :label="item.defectType"></el-option>
                </el-select>
              </report-td>
              <!-- 缺陷类别2级 -->
              <report-td v-if="data.showSecond" :title="h_i18n('09cc8af64ed2731917a65bff55950d8f')" colspan="4:8" required>
                <el-tooltip effect="redTip" placement="top" :disabled="false" :visible="data.secondDefectTypeFlag" :content="h_i18n('dbbb5ebbcae04dbb570e0c6d472b2797')">
                  <div style="position: absolute;width:40%"></div>
                </el-tooltip>
                <el-select :disabled="postData.borrowProductNum || data.secondDefectTypeList.length < 1 || !postData.defectType" v-model="postData.secondDefectType" clearable filterable @change="changeSecondDefectType">
                  <el-option v-for="item in data.secondDefectTypeList" :key="item.id" :value="item.secondDefectType" :label="item.secondDefectType"></el-option>
                </el-select>
              </report-td>
              <report-td v-else colspan="4:8"></report-td>
            </tr>
            <tr>
              <!-- 是否芯片类缺陷 -->
              <report-td :title="h_i18n('B554F99C421BCEA6A5F4E774C3177B3A')" colspan="4:8" required>
                <el-tooltip effect="redTip" placement="top" :disabled="false" :visible="data.chip.chipDefectFlag" :content="h_i18n('B554F99C421BCEA6A5F4E774C3177B3A')+h_i18n('281bada7259f6bcb836f62aa0b3e8f48')">
                  <div style="position: absolute;width:40%"></div>
                </el-tooltip>
                <el-select disabled v-model="postData.chip" clearable filterable>
                  <el-option v-for="item in [{value:'1',label:'是'},{value:'0',label:'否'}]" :key="item.label" :value="item.value" :label="item.label"></el-option>
                </el-select>
              </report-td>
              <report-td v-if="postData.chip !== '1'" colspan="4:8"></report-td>
              <!-- 是否海尔领料 -->
               <report-td v-else :title="h_i18n('CA13718E00334155166F356270E0F43F')" colspan="4:8" required>
                <el-tooltip effect="redTip" placement="top" :disabled="false" :visible="data.chip.isHaierPickingFlag" :content="h_i18n('CA13718E00334155166F356270E0F43F')+h_i18n('281bada7259f6bcb836f62aa0b3e8f48')">
                  <div style="position: absolute;width:28%"></div>
                </el-tooltip>
                <el-select :disabled="postData.borrowProductNum" v-model="postData.haierMaterialPicking" clearable filterable @change="isHaierPickingChange">
                  <el-option v-for="item in [{value:'1',label:'是'},{value:'0',label:'否'}]" :key="item.id" :value="item.value" :label="item.label"></el-option>
                </el-select>
               </report-td>
            </tr>
            <tr v-if="postData.chip === '1'">
              <!-- 二级物料商 -->
              <report-td :title="h_i18n('A4D25890112C90B1B753D19324159AD8')" colspan="4:8" required :question="true">
                  <template #tipText>
                    <!-- 是否海尔物料 = 是，数据取自 -->
                    <span>{{ h_i18n('6EFE532B72BEFE69D52769B0F8DE9464') }}</span> 
                    <!-- 【采购二级物料商】 -->
                    <!-- 信息，数据由海尔方提供，不可更改；是否海尔物料=否，由供应商在 -->
                    <!-- 【非海尔领料二级物料商】 -->
                    <!-- 中维护；（超链接可跳转至相关页面） -->
                  </template>
                <el-tooltip effect="redTip" placement="top" :disabled="false" :visible="data.chip.Level2SupplierFlag" :content="h_i18n('A4D25890112C90B1B753D19324159AD8')+h_i18n('281bada7259f6bcb836f62aa0b3e8f48')">
                  <div style="position: absolute;width:28%"></div>
                </el-tooltip>
                <div style="display: flex;">
                  <el-select :disabled="postData.borrowProductNum" v-model="postData.secondSupplyCode" clearable filterable @change="level2SupplyChange">
                    <el-option v-for="item in data.chip.Level2SupplierList" :key="item.id" :value="item.secondSupplyCode" :label="item.secondSupplyName === '无' ? item.secondSupplyName :item.secondSupplyCode+'-'+item.secondSupplyName"></el-option>
                  </el-select>
                  <!-- 新增 -->
                  <h-button type="primary" style="margin-left: 12px;" :disabled="postData.haierMaterialPicking !== '0'" @click="addLevel2('supplier')">{{ h_i18n('66ab5e9f24c8f46012a25c89919fb191') }}</h-button>
                </div>
              </report-td>
              <!-- 二级物料 -->
               <report-td :title="h_i18n('0DFE5FF46AD645508536D9E48897CFD6')" colspan="4:8" required :question="true">
                <template #tipText>
                  <!-- 是否海尔物料 = 是，数据取自 -->
                  <!-- 【采购二级物料】 -->
                  <!-- 信息，数据由海尔方提供，不可更改；是否海尔物料=否，由供应商在 -->
                  <!-- 【非海尔领料二级物料】 -->
                  <!-- 中维护；-->
                  <span>{{ h_i18n('648D61F63F3FD6D59F606C31E42E76FA') }}</span>
                </template>
                <el-tooltip effect="redTip" placement="top" :disabled="false" :visible="data.chip.Level2MaterialsFlag" :content="h_i18n('0DFE5FF46AD645508536D9E48897CFD6')+h_i18n('281bada7259f6bcb836f62aa0b3e8f48')">
                  <div style="position: absolute;width:28%"></div>
                </el-tooltip>
                <div style="display: flex;">
                  <el-select :disabled="postData.borrowProductNum" v-model="postData.secondMtlNo" clearable filterable @change="level2MtlChange">
                    <el-option v-for="item in data.chip.Level2MaterialsList" :key="item.id" :value="item.secondMtlNo" :label="item.secondMtlName === '无' ? item.secondMtlName : item.secondMtlNo+'-'+item.secondMtlName"></el-option>
                  </el-select>
                  <!-- 新增 -->
                  <h-button type="primary" style="margin-left: 12px;" :disabled="postData.haierMaterialPicking !== '0'" @click="addLevel2('materials')">{{ h_i18n('66ab5e9f24c8f46012a25c89919fb191') }}</h-button>
                </div>
               </report-td>
            </tr>
            <tr v-if="postData.chip === '1'">
              <!-- 二级物料生产批次 -->
              <report-td :title="h_i18n('DCA9AC19732B446712D77E4FB89A9DE5')" colspan="4:20" required :question="true">
                <template #tipText>
                  <!-- 多个批次请用逗号隔开 -->
                  <span>{{ h_i18n('F9EF0249D744799B3C921D98305F2884') }}</span> 
                </template>
                <el-tooltip effect="redTip" placement="top" :disabled="false" :visible="data.chip.Level2MaterialProductionBatchFlag" :content="h_i18n('DCA9AC19732B446712D77E4FB89A9DE5')+h_i18n('281bada7259f6bcb836f62aa0b3e8f48')">
                  <el-input :disabled="postData.borrowProductNum" v-model="postData.secondSupplyBatch" type="textarea" maxlength="1000" show-word-limit :rows="1"></el-input>
                </el-tooltip>
              </report-td>
            </tr>
            <tr>
              <!-- 供应商责任节点 -->
              <report-td :title="h_i18n('d9de5a8ab5d67be36522a0303d8f4dfa')" colspan="4:8" required>
                <el-tooltip effect="redTip" placement="top" :disabled="false" :visible="data.supplyDutyNodeFlag" :content="h_i18n('58ab17a28ca510581732f19dfcab9716')">
                  <div style="position: absolute;width:40%"></div>
                </el-tooltip>
                <el-select :disabled="postData.borrowProductNum" v-model="postData.supplyDutyNode" clearable filterable @change="(v)=>{!v && (postData.supplyDutyNode = undefined)}">
                  <el-option value="设计" :label="h_i18n('b08890a6ef3b65218573ed90770b08fd')"></el-option>
                  <el-option value="制造" :label="h_i18n('184219e01bc9df50cc3783cd0b9b9411')"></el-option>
                  <el-option value="采购" :label="h_i18n('d2f8889432e7cddc810c2a2365bc5916')"></el-option>
                  <el-option value="运输" :label="h_i18n('0f3a252acc620f29d0ff2251ef0a1186')"></el-option>
                  <el-option value="其他" :label="h_i18n('0d98c74797e49d00bcc4c17c9d557a2b')"></el-option>
                </el-select>
              </report-td>
              <!-- 分析应完成时间 -->
              <report-td :title="h_i18n('cd7b92d14b0791a00d0051332150abc8')" colspan="4:8">{{ time(getData.analysisShouldDate,6) }}</report-td>
            </tr>
            <tr>
              <!-- 分析实际完成时间 -->
              <report-td :title="h_i18n('115bd62a3f084e5c0c300a4a1a377c70')" colspan="4:8">
                {{ postData.supplyTrueName }} &nbsp;&nbsp;
                {{ time(postData.analysisActualDate,6) }}
              </report-td>
              <report-td :title="h_i18n('e6135ccba176bc6ea0c470f6824d5df1')" colspan="4:8" required>
                <el-tooltip effect="redTip" placement="top" :disabled="false" :visible="data.improvedStateFlag" :content="h_i18n('9b8489e92249308367b64451ddbdeaaa')">
                  <div style="position: absolute;width:40%"></div>
                </el-tooltip>
                <el-select :disabled="postData.borrowProductNum" v-model="postData.improvedState" clearable filterable @change="(v)=>{!v && (postData.improvedState = undefined)}">
                  <el-option value="改善前" :label="h_i18n('4081583fe18e92e871c989b9d1854e57')"></el-option>
                  <el-option value="改善后" :label="h_i18n('54d292c17cfabdbea14792f8cfdae207')"></el-option>
                </el-select>
              </report-td>
            </tr>
            <tr>
              <report-td :title="h_i18n('020ae67061284fe42a87f44b88725888')" colspan="4:20" required>
                <!-- <span style="color: #2164f5; cursor: pointer; text-overflow: ellipsis; overflow: hidden; display: inline-block"
                @click="openDefectPhoto(getData.defectPhotoUuid)">{{ getData.defectPhotoName }}</span> -->
                <el-tooltip effect="redTip" placement="top" :disabled="false" :visible="data.defectPhotoUuidFlag" :content="h_i18n('6b415a2f731a9c3ec206f451542e62c6')">
                  <div style="position: absolute;width:40%"></div>
                </el-tooltip>
                <h-button @click="openUpFileDialogShow" type="primary">{{ h_i18n('8d0cfb582a50e3872522d075934cff44') }}</h-button>
                <div style="display: flex;flex:1;overflow-x: auto" v-if="data.fileUploadToOss.length>0">
                  <div style="display: flex;flex-direction: column;cursor: pointer;padding: 5px 0">
                    <div style="color: #2681ff;" v-for="(v,i) in data.fileUploadToOss"
                        @click="openDefectPhoto(v.filePath)" :key="i">{{ v.fileName }}
                    </div>
                  </div>
                </div>
              </report-td>
            </tr>
            <tr>
              <report-td :title="h_i18n('865de93e8ab606461412ce83276fe180')" colspan="4:20">
                <!-- <span style="color: #2164f5; cursor: pointer; text-overflow: ellipsis; overflow: hidden; display: inline-block"
                 @click="openDefectPhoto(getData.replenishUuid)">{{ getData.replenishName }}</span> -->
                <hc-file-upload download delete v-model="data.fileTemp" accept="all" size="30"
                  :info="h_i18n('0a94aa92aebd0d07cd2fffcb3c3b545f')" @error="errorFile" @delete="deleteFun" @download="download" @change="fileChange">
                </hc-file-upload>
              </report-td>
            </tr>
          </form-body>
        </template>
        <!-- 查看 -->
        <template v-else>
          <form-body v-if="value===h_i18n('eba745696b4f04640b0b00ebd4d7309f')">
            <tr>
              <!-- 供应商补充OID -->
              <report-td :title="h_i18n('33239986C13032CDE38FC5FFD148BD31')" colspan="4:20">
                {{ getData.supplementOid || '-'}}
              </report-td>
            </tr>
            <tr>
              <report-td :title="h_i18n('7b9fa22a7fb8ed240412c78df089ed1b')" colspan="4:20" :question="true">
                <template #tipText>
                  <div>{{ h_i18n('b79302dd8bcee65f2e104c903a3f01e8') }}</div>
                </template>
                <span style="color: #2164f5; cursor: pointer; text-overflow: ellipsis; overflow: hidden; display: inline-block"
                  @click="openBorrowProductNum()">
                  {{ getData.borrowProductNum }}
                </span>
              </report-td>
            </tr>
            <tr>
              <report-td :title="h_i18n('104254c1b29bd1eedd493570dd7d5d9f')" colspan="4:20">{{ getData.analysisConclusion }}</report-td>
            </tr>
            <tr>
              <!-- 缺陷类别1级 -->
              <report-td :title="h_i18n('fb3efdaa003c37ac0646cab99ca2ea26')" colspan="4:8">{{ getData.defectType }}</report-td>
              <!-- 缺陷类别2级 -->
              <report-td :title="h_i18n('09cc8af64ed2731917a65bff55950d8f')" colspan="4:8">{{ getData.secondDefectType }}</report-td>
            </tr>
            <tr>
              <!-- 是否芯片类缺陷 -->
              <report-td :title="h_i18n('B554F99C421BCEA6A5F4E774C3177B3A')" :colspan="getData.chip !== '1' ? '4:20' : '4:8'">
                <span v-if="getData.chip === '1'">{{ h_i18n('0a60ac8f02ccd2cf723f927284877851') }}</span>
                <span v-else-if="getData.chip === '0'">{{ h_i18n('c9744f45e76d885ae1c74d4f4a934b2e') }}</span>
                <span v-else>-</span>
              </report-td>
              <!-- 是否海尔领料 -->
              <report-td v-if="getData.chip === '1'" :title="h_i18n('CA13718E00334155166F356270E0F43F')" colspan="4:8">
                <span v-if="getData.haierMaterialPicking === '1'">{{ h_i18n('0a60ac8f02ccd2cf723f927284877851') }}</span>
                <span v-else-if="getData.haierMaterialPicking === '0'">{{ h_i18n('c9744f45e76d885ae1c74d4f4a934b2e') }}</span>
                <span v-else>-</span>
               </report-td>
            </tr>
            <tr v-if="getData.chip === '1'">
              <!-- 二级物料商 -->
              <report-td :title="h_i18n('A4D25890112C90B1B753D19324159AD8')" colspan="4:8">
                {{ getData.secondSupplyCode }}-{{ getData.secondSupplyName }}
              </report-td>
              <!-- 二级物料 -->
              <report-td :title="h_i18n('0DFE5FF46AD645508536D9E48897CFD6')" colspan="4:8">
                {{ getData.secondMtlNo }}-{{ getData.secondMtlName }}
              </report-td>
            </tr>
            <tr v-if="getData.chip === '1'">
              <!-- 二级物料生产批次 -->
              <report-td :title="h_i18n('DCA9AC19732B446712D77E4FB89A9DE5')" colspan="4:20">
                {{ getData.secondSupplyBatch || '-' }}
              </report-td>
            </tr>
            <tr>
              <report-td :title="h_i18n('d9de5a8ab5d67be36522a0303d8f4dfa')" colspan="4:8">
                <!-- {{ getData.supplyDutyNode }} -->
                <span v-if="getData.supplyDutyNode === '设计'">{{ h_i18n('b08890a6ef3b65218573ed90770b08fd') }}</span>
                <span v-else-if="getData.supplyDutyNode === '制造'">{{ h_i18n('184219e01bc9df50cc3783cd0b9b9411') }}</span>
                <span v-else-if="getData.supplyDutyNode === '采购'">{{ h_i18n('d2f8889432e7cddc810c2a2365bc5916') }}</span>
                <span v-else-if="getData.supplyDutyNode === '运输'">{{ h_i18n('0f3a252acc620f29d0ff2251ef0a1186') }}</span>
                <span v-else-if="getData.supplyDutyNode === '其他'">{{ h_i18n('0d98c74797e49d00bcc4c17c9d557a2b') }}</span>
                <span v-else></span>
              </report-td>
              <report-td :title="h_i18n('cd7b92d14b0791a00d0051332150abc8')" colspan="4:8">{{ time(getData.analysisShouldDate,6) }}</report-td>
            </tr>
            <tr>
              <report-td :title="h_i18n('115bd62a3f084e5c0c300a4a1a377c70')" colspan="4:8">
                <template v-if="kindType == 'detail'">{{ getData.supplyTrueName }} &nbsp;&nbsp;</template>
                {{ time(getData.analysisActualDate,6) }}</report-td>
              <report-td :title="h_i18n('e6135ccba176bc6ea0c470f6824d5df1')" colspan="4:8">
                <!-- {{ getData.improvedState }} -->
                <span v-if="getData.improvedState === '改善前'">{{ h_i18n('4081583fe18e92e871c989b9d1854e57') }}</span>
                <span v-else-if="getData.improvedState === '改善后'">{{ h_i18n('54d292c17cfabdbea14792f8cfdae207') }}</span>
                <span v-else></span>
              </report-td>
            </tr>
            <tr>
              <report-td :title="h_i18n('020ae67061284fe42a87f44b88725888')" colspan="4:20">
                <template v-if="getData.defectPhotoUuid && getData.defectPhotoUuid.split(',').length > 1">
                  <span v-for="(item,i) in getData.defectPhotoUuid.split(',')" :key="i" style="color: #2164f5; cursor: pointer; text-overflow: ellipsis; overflow: hidden; display: block"
                   @click="openDefectPhoto(item)">{{ getData.defectPhotoName.split(',')[i] }}</span>
                </template>
                <span v-else style="color: #2164f5; cursor: pointer; text-overflow: ellipsis; overflow: hidden; display: inline-block"
                @click="openDefectPhoto(getData.defectPhotoUuid)">{{ getData.defectPhotoName }}</span>
              </report-td>
            </tr>
            <tr>
              <report-td :title="h_i18n('865de93e8ab606461412ce83276fe180')" colspan="4:20">
                <span style="color: #2164f5; cursor: pointer; text-overflow: ellipsis; overflow: hidden; display: inline-block"
                 @click="openDefectPhoto(getData.replenishUuid)">{{ getData.replenishName }}</span>
              </report-td>
            </tr>
          </form-body>
        </template>
        <form-body v-if="value===h_i18n('acda736d85c260c17b9bbf0ccaf9278b')">
          <template v-if="kindType != 'audit'">
            <tr>
              <report-td :title="h_i18n('8c4ab5982fcea30b260715ac494e7922')" colspan="4:20">
                <el-radio-group disabled v-model="getData.sqeAuditConclusion">
                  <el-radio label="P">{{ h_i18n('23c1f39900b3af4c3263449782e288e1') }}</el-radio>
                  <el-radio label="F">{{ h_i18n('dec0624c91cfca219e1b41ce89c19780') }}</el-radio>
                  <!-- <el-radio label="R">驳回</el-radio> -->
                </el-radio-group>
              </report-td>
            </tr>
          </template>
          <tr>
            <report-td :title="h_i18n('ab1bcd732b932ead763bf080d90e93ab')" colspan="4:20" required>
              <el-input v-if="kindType == 'audit'" v-model="postData.sqeAuditMessage" type="textarea" maxlength="200" show-word-limit :rows="3" class="td-input-style"></el-input>
              <template v-else-if="kindType == 'detail'">{{ getData.sqeAuditMessage }}</template>
              <template v-else-if="kindType == 'save'">{{ getData.sqeAuditMessage }}</template>
            </report-td>
          </tr>
          <tr>
            <report-td :title="h_i18n('e6f0708789d7efc02f1a163224ae7fb0')" colspan="4:20">
              <template v-if="kindType == 'audit'">
                {{ time(postData.sqeAuditTime,6) }}
              </template>
              <template v-else>
                {{ time(getData.sqeAuditTime,6) }}
              </template>
            </report-td>
          </tr>
        </form-body>
      </template>
      <template #footer>
        <h-button-group align="center">
          <template v-if="kindType == 'audit'">
            <h-button @click="submitPass" type="primary" size="small" :loading="subLoading">{{ h_i18n('23c1f39900b3af4c3263449782e288e1') }}</h-button>
            <h-button @click="submitOverrule" type="danger" size="small" :loading="subLoading">{{ h_i18n('32525478cd5c1c93de9c71246021b595') }}</h-button>
          </template>
          <template v-if="kindType == 'save'">
            <h-button @click="save" type="primary" size="small" :loading="subLoading">{{ h_i18n('d8acae3bcfbc9ec9ade58c2dbacf65aa') }}</h-button>
            <h-button @click="submit" type="primary" size="small" :loading="subLoading">{{ h_i18n('939d5345ad4345dbaabe14798f6ac0f1') }}</h-button>
          </template>
          <h-button @click="routerBack" type="primary" size="small">{{ h_i18n('5f411223ca5a01a5adf20fe735a433d0') }}</h-button>
        </h-button-group>
      </template>
    </form-area>
  </h-form-page>

   <!--上传-->
   <h-dialog :show="data.upFileDialogShow" :title="h_i18n('020ae67061284fe42a87f44b88725888')" footer @close="data.upFileDialogShow = false" width="560px">
    <h-upload @file-change="chooseFile" :max="30" :max-length="10" @error="errorFile"
      :file-list="data.fileAddArr" h-accept="png,jpg,jpeg,JPG,JPEG,PNG" accept="image/png, image/jpeg ,.jpg,.jpeg,.png,.JPG,.JPEG,.PNG">
      <template #tips>
        <div>{{ h_i18n('1482318b392834e712379d6ce33988b8') }}</div>
        <div>{{ h_i18n('7d3bf4bdd792ca6fb0ef506c06f6214f') }}</div>
        <div>{{ h_i18n('6e6285bc701a98469a7b99c9dbd7e994') }}</div>
        <div>{{ h_i18n('20c79009e600b8dab6aedf6e537e789c') }}</div>
        <div>{{ h_i18n('1f73e98b0843f3fab480ecd8414df313') }}</div>
        <div>{{ h_i18n('c887f3e1c6cddb36ddac05c8371ad2c7') }}</div>
      </template>
    </h-upload>
    <template #footer>
      <h-button-group align="right">
        <h-button type="primary" @click="uploadFile" :loading="data.uploadLoading">{{ h_i18n('e83a256e4f5bb4ff8b3d804b5473217a') }}</h-button>
      </h-button-group>
    </template>
  </h-dialog>
  <!-- 借用分析机编 不良分析借用 -->
  <h-dialog class="dialog_style" :title="h_i18n('6f5d930c0bca7171e00a90dfffb60999')" :show="data.showBorrowProductNum" width="70%" @close="closeborrowProductDialog" footer>
    <h-list-page class="dialog_list_style">
    <h-card width="100%" is-search style="padding-top:0px;">
        <h-area title-width="90px" :all-span="7" style="padding: 0">
          <h-search :title="h_i18n('17d4f56ede5d971b3908ac3d2ed21054')">
            <h-input :placeholder="h_i18n('02cc4f8f5a9aefbc03c778f7a5c989c7')" v-model="searchData.productNum" clearable></h-input>
          </h-search>

          <h-button type="primary" :loading="data.loading" @click="searchBorrowProductNum()">
            <template #icon>
              <search/>
            </template>{{ h_i18n('bee912d79eefb7335988c4997aa9138d') }}</h-button>
        </h-area>
      </h-card>
        <el-table :empty-text="h_i18n('ae6800a61ec1410f8bdc8720bdf6590c')" border v-loading="data.borrowloading" size="small"
        :data="data.borrowDataList" height="540" @selection-change="listCheckBoxChange" style="width: 100%">
          <el-table-column type="selection" width="35"></el-table-column>
          <el-table-column type="index" :label="h_i18n('faaadc447b1c2b1adc920d9c9aedcc25')"></el-table-column>
          <el-table-column prop="productNum" :label="h_i18n('17d4f56ede5d971b3908ac3d2ed21054')" min-width="170"></el-table-column>
          <el-table-column prop="analysisConclusion" :label="h_i18n('104254c1b29bd1eedd493570dd7d5d9f')" min-width="110"></el-table-column>
          <el-table-column prop="defectType" :label="h_i18n('fb3efdaa003c37ac0646cab99ca2ea26')" min-width="90"></el-table-column>
          <el-table-column prop="secondDefectType" :label="h_i18n('09cc8af64ed2731917a65bff55950d8f')" min-width="90"></el-table-column>
          <el-table-column prop="supplyDutyNode" :label="h_i18n('7e991e3e14d04ed7893f3ea272a31fe6')" min-width="90">
            <template #default="{ row }">
              <span v-if="row.supplyDutyNode === '设计'">{{ h_i18n('b08890a6ef3b65218573ed90770b08fd') }}</span>
              <span v-else-if="row.supplyDutyNode === '制造'">{{ h_i18n('184219e01bc9df50cc3783cd0b9b9411') }}</span>
              <span v-else-if="row.supplyDutyNode === '采购'">{{ h_i18n('d2f8889432e7cddc810c2a2365bc5916') }}</span>
              <span v-else-if="row.supplyDutyNode === '运输'">{{ h_i18n('0f3a252acc620f29d0ff2251ef0a1186') }}</span>
              <span v-else-if="row.supplyDutyNode === '其他'">{{ h_i18n('0d98c74797e49d00bcc4c17c9d557a2b') }}</span>
              <span v-else></span>
            </template>
          </el-table-column>
          <el-table-column prop="improvedState" :label="h_i18n('e6135ccba176bc6ea0c470f6824d5df1')" min-width="90">
            <template #default="{ row }">
              <span v-if="row.improvedState === '改善前'">{{ h_i18n('4081583fe18e92e871c989b9d1854e57') }}</span>
              <span v-else-if="row.improvedState === '改善后'">{{ h_i18n('54d292c17cfabdbea14792f8cfdae207') }}</span>
              <span v-else></span>
            </template>
          </el-table-column>
          <el-table-column prop="analysisActualDate" :label="h_i18n('97ccbb8d4088f4726ea4ed44e9558f49')" min-width="170">
            <template #default="{ row }">
              <span>{{ time(row.analysisActualDate, 6) }}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background @current-change="dialogCurrentChange" v-model:currentPage="searchData.pageNo"
          :page-size="10" layout="total, prev, pager, next,jumper" :total="data.dialogTotal" :hide-on-single-page="true">
        </el-pagination>
      </h-list-page>
      <template #footer>
        <h-button-group align="center">
          <h-button type="primary" @click="borrowBtn()" style="margin-left: 20px;">{{ h_i18n('5d971fd19163b05640a0d04c894a3ea7') }}</h-button>
          <h-button type="primary" @click="closeborrowProductDialog()" style="margin-left: 20px;">{{ h_i18n('5f411223ca5a01a5adf20fe735a433d0') }}</h-button>
        </h-button-group>
      </template>
    </h-dialog>
  <h-dialog class="addl2dialog" :title="h_i18n('66ab5e9f24c8f46012a25c89919fb191') + data.chip.addDialogShow" :show="!!data.chip.addDialogShow" width="560px" @close="l2AddClose" footer>
    <h-row class="addl2row">
      <!-- 基本信息 -->
      <h-col :span="24" class="addl2col_b">
        <!-- 供应商代码 -->
        <div class="addl2title">{{ h_i18n('1b7ecd2bdbd8a1a112dead57724f06df') }} </div>
        <span>{{ getData.supplyCode }}</span>
      </h-col>
      <h-col :span="24" class="addl2col_b">
        <!-- 供应商名称 -->
        <div class="addl2title">{{ h_i18n('9190cc22c9ba377113bc54ac51013a0b') }} </div>
        <span>{{ getData.supplyName }}</span>
      </h-col>
      <!-- 二级物料商 显示内容  -->
      <template v-if="data.chip.addDialogShow === h_i18n('A4D25890112C90B1B753D19324159AD8')">
        <h-col :span="24" class="addl2col_s">
          <!-- 二级物料商代码 -->
          <div class="addl2title">{{ h_i18n('A4D25890112C90B1B753D19324159AD8') + h_i18n('06e004ef21414c06d3e4ff2cefaf6a04') }}<span class="addl2required">*</span></div>
          <el-tooltip effect="redTip" placement="top" :disabled="false" :visible="data.chip.level2SupplyCodeFlag" :content="h_i18n('A4D25890112C90B1B753D19324159AD8') + h_i18n('06e004ef21414c06d3e4ff2cefaf6a04') + h_i18n('281bada7259f6bcb836f62aa0b3e8f48')">
            <el-input :placeholder="h_i18n('02cc4f8f5a9aefbc03c778f7a5c989c7')" v-model="level2Add.secondSupplyCode" clearable maxlength="100" show-word-limit ></el-input>
          </el-tooltip>
        </h-col>
        <h-col :span="24" class="addl2col_s">
          <!-- 二级物料商名称 -->
          <div class="addl2title">{{ h_i18n('A4D25890112C90B1B753D19324159AD8') + h_i18n('d7ec2d3fea4756bc1642e0f10c180cf5') }}<span class="addl2required">*</span></div>
          <el-tooltip effect="redTip" placement="top" :disabled="false" :visible="data.chip.level2SupplyNameFlag" :content="h_i18n('A4D25890112C90B1B753D19324159AD8') + h_i18n('d7ec2d3fea4756bc1642e0f10c180cf5') + h_i18n('281bada7259f6bcb836f62aa0b3e8f48')">
            <el-input :placeholder="h_i18n('02cc4f8f5a9aefbc03c778f7a5c989c7')" v-model="level2Add.secondSupplyName" clearable maxlength="500" show-word-limit ></el-input>
          </el-tooltip>
        </h-col>
        <h-col class="add2col_n">
          <div>
            1.{{ h_i18n('A34DA1C9B63AD9224F07CC406BE3EAB7') }}
          </div>
        </h-col>
        <h-col class="add2col_n">
          <div>
            2.{{ h_i18n('6050E9269C86A9921B32119B1E308959') }}
          </div>
        </h-col>
      </template>
      <!-- 二级物料 显示内容 -->
      <template v-if="data.chip.addDialogShow === h_i18n('0DFE5FF46AD645508536D9E48897CFD6')">
        <h-col :span="24" class="addl2col_s">
          <!-- 二级物料号 -->
          <div class="addl2title">{{ h_i18n('0DFE5FF46AD645508536D9E48897CFD6') + h_i18n('CA48979ECBAA70271646C73B9DAE03CB') }}<span class="addl2required">*</span></div>
          <el-tooltip effect="redTip" placement="top" :disabled="false" :visible="data.chip.level2MtlNoFlag" :content="h_i18n('0DFE5FF46AD645508536D9E48897CFD6') + h_i18n('CA48979ECBAA70271646C73B9DAE03CB') + h_i18n('281bada7259f6bcb836f62aa0b3e8f48')">
            <el-input :placeholder="h_i18n('02cc4f8f5a9aefbc03c778f7a5c989c7')" v-model="level2Add.secondMtlNo" clearable maxlength="100" show-word-limit></el-input>
          </el-tooltip>
        </h-col>
        <h-col :span="24" class="addl2col_s">
          <!-- 二级物料描述 -->
          <div class="addl2title">{{ h_i18n('0DFE5FF46AD645508536D9E48897CFD6') + h_i18n('3bdd08adab6ea90b9164b20a0e4151ac') }}<span class="addl2required">*</span></div>
          <el-tooltip effect="redTip" placement="top" :disabled="false" :visible="data.chip.level2MtlNameFlag" :content="h_i18n('0DFE5FF46AD645508536D9E48897CFD6') + h_i18n('3bdd08adab6ea90b9164b20a0e4151ac') + h_i18n('281bada7259f6bcb836f62aa0b3e8f48')">
            <el-input :placeholder="h_i18n('02cc4f8f5a9aefbc03c778f7a5c989c7')" v-model="level2Add.secondMtlName" clearable maxlength="500" show-word-limit></el-input>
          </el-tooltip>
        </h-col>
        <h-col class="add2col_n">
          <div>
            1.{{ h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca') }}
          </div>
        </h-col>
        <h-col class="add2col_n">
          <div>
            2.{{ h_i18n('6050E9269C86A9921B32119B1E308959') }}
          </div>
        </h-col>
      </template>
    </h-row>
    <template #footer>
      <h-button-group align="center">
        <h-button @click="l2AddSPMTBtn" :loading="data.chip.l2AddBtnLoading" type="primary">{{ h_i18n('939d5345ad4345dbaabe14798f6ac0f1') }}</h-button>
        <h-button @click="l2AddClose" type="default">{{ h_i18n('5f411223ca5a01a5adf20fe735a433d0') }}</h-button>
      </h-button-group>
    </template>
  </h-dialog>
</template>



<script setup>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

import {reactive,getCurrentInstance,onMounted, onBeforeMount, nextTick, onUpdated, ref, defineEmit, computed} from "vue";
  import { useRoute } from "vue-router";
  const { proxy, ctx } = getCurrentInstance();
  const route = useRoute();
  const emit = defineEmit(
    ['submit','auditBtn','tabChange','routerBack','submitPass','submitOverrule','save','submitSave']
  )
  const props = defineProps({
    kindType: {
      type: String,
      default: ''
      // sqm详情: detail ,sqm提交/保存: save , Hmqm详情: particulars Hmqm审核: audit 
    },
    getData: {
      type:Object,
      default: {}
    },
    subLoading:{
      type:Boolean,
      default:false,
    }
  })
  const searchData = reactive({
    analysisStatus:'审核通过',
    ifBrorrow:0,
    brorrowFlag:'1',
    pageNo:1,
    pageSize:10,
  })
  const data = reactive({
    borrowDataList:[],
    borrowloading:false,
    title:'',
    titleList:[],
    firstType:false, // 第一次分析
    secondType:false, // 暂存后
    reType:false, // 驳回后
    showBorrowProductNum:false,
    analysisConclusionFlag:false,
    chip:{ // 芯片相关字段
      level2SupplyCodeFlag:false,
      level2SupplyNameFlag:false,
      level2MtlNoFlag:false,
      level2MtlNameFlag:false,
      addDialogShow:null,
      Level2SupplierList:[],
      Level2MaterialsList:[],
      supplyOIDFlag:false,
      supplyOIDText: h_i18n('33239986C13032CDE38FC5FFD148BD31')+h_i18n('281bada7259f6bcb836f62aa0b3e8f48'),
      chipDefectFlag:false,
      isHaierPickingFlag:false,
      Level2SupplierFlag:false,
      Level2MaterialsFlag:false,
      Level2MaterialProductionBatchFlag:false,
      l2AddBtnLoading:false,
    },
    defectTypeFlag:false,
    secondDefectTypeFlag:false,
    improvedStateFlag:false,
    supplyDutyNodeFlag:false,
    defectPhotoUuidFlag:false,
    defectTypeList:[],
    secondDefectTypeList:[],
    upFileDialogShow:false,
    fileAddArr:[],
    uploadLoading:false,
    fileUploadToOss:[],
    fileTemp:{},
    showSecond:false,
  })
  const level2Add = reactive({})
  const postData = reactive({
    sqeAuditTime:new Date(),
    chip:null,
    haierMaterialPicking:null,
  })
  // 超链接方法
  // const openLine = (str) => {

  // }
  // 二级物料/商 新增窗口
  const addLevel2 = (type) => {
    if(type === 'materials'){
      // 二级物料
      data.chip.addDialogShow = h_i18n('0DFE5FF46AD645508536D9E48897CFD6')
    }else if(type === 'supplier'){
      // 二级物料商
      data.chip.addDialogShow = h_i18n('A4D25890112C90B1B753D19324159AD8')
    }
  }
  // 添加
  const l2AddSPMTBtn = () => {
    if(data.chip.addDialogShow === h_i18n('0DFE5FF46AD645508536D9E48897CFD6')){
      // 二级物料
      // data.chip.Level2MaterialsList.push({value:level2Add.secondMtlNo,label:level2Add.secondMtlName})
      // 校验字段
      if(!level2Add.secondMtlNo){
        data.chip.level2MtlNoFlag = true
        data.chip.l2AddBtnLoading = true;
        setTimeout(() => {
          data.chip.level2MtlNoFlag = false;
          data.chip.l2AddBtnLoading = false;
        }, 2000);
        return
      }
      if(!level2Add.secondMtlName){
        data.chip.level2MtlNameFlag = true;
        data.chip.l2AddBtnLoading = true;
        setTimeout(() => {
          data.chip.level2MtlNameFlag = false;
          data.chip.l2AddBtnLoading = false;
        }, 2000);
        return
      }
      l2MOrSAdd('Level2MaterialsList')
    }else if(data.chip.addDialogShow === h_i18n('A4D25890112C90B1B753D19324159AD8')){
      // 二级物料商
      // data.chip.Level2SupplierList.push({value:level2Add.secondSupplyCode,label:level2Add.secondSupplyName})
      // 校验字段
      if(!level2Add.secondSupplyCode){
        data.chip.level2SupplyCodeFlag = true
        data.chip.l2AddBtnLoading = true;
        setTimeout(() => {
          data.chip.level2SupplyCodeFlag = false;
          data.chip.l2AddBtnLoading = false;
        }, 2000);
        return
      }
      if(!level2Add.secondSupplyName){
        data.chip.level2SupplyNameFlag = true;
        data.chip.l2AddBtnLoading = true;
        setTimeout(() => {
          data.chip.level2SupplyNameFlag = false;
          data.chip.l2AddBtnLoading = false;
        }, 2000);
        return
      }
      l2MOrSAdd('Level2SupplierList')
    }
  }
  // 关闭添加窗口,清理数据
  const l2AddClose = () => {
    data.chip.addDialogShow = null
    Object.keys(level2Add).forEach(key => {
      delete level2Add[key]
    })
    data.chip.l2AddBtnLoading = false;
  }
  // 二级物料添加接口 成功则添加并更新/失败则返回提示
  // 二级物料商添加接口 成功则添加并更新/失败则返回提示
  const l2MOrSAdd = (to) => {
    let url = ''
    let subData = {
      // createTime: proxy.time(new Date().getTime(),6),
      supplyCode: props.getData.supplyCode,
      supplyName: props.getData.supplyName,
      name: route.query.userName,
      nickName: route.query.trueName,
      ...level2Add
    }
    if(to === 'Level2MaterialsList'){
      // 添加二级物料
      url = '/base/ecosphere/saveSecondMaterial'
    }else if(to === 'Level2SupplierList'){
      // 添加二级供应商
      url = '/base/ecosphere/saveSecondMaterialSupply'
    }
    data.chip.l2AddBtnLoading = true;
    proxy.$http({
      url:url,
      method:'post',
      data:subData
    }).then(res=>{
      if(res.data.code === '200'){
        proxy.success(res.data.msg)
        getL2ListOf(to)
        // 添加成功后关闭添加窗口,清理数据
        l2AddClose()
      }else{
        proxy.warning(res.data.msg)
      }
    }).catch(err=>{

    }).finally(()=>{
      data.chip.l2AddBtnLoading = false;
    })
  }
  // 查询海尔领料二级信息
  const getL2ListOfHaier = (name) => {
    let url  = ''
    if(name === 'Level2MaterialsList'){
      url ='ecosphere/sqmSecondMaterialList'
    }else if(name === 'Level2SupplierList'){
      url = 'ecosphere/sqmSecondSupplyList'
    }else{
      return
    }
    proxy.$http({
      url: '/base/' + url,
      method: 'post',
      data:{
        supplyCode: props.getData.supplyCode,
        pageSize: 9999,
        pageNo: 1,
        mtlNo: props.getData.mtlNo,
        fixConfig: true
      }
    }).then(res => {
      if (res.data.code === '200') {
        data.chip[name] = res.data.data.records
      } else {
        proxy.warning(res.data.msg)
      }
    })
    .catch(err => {
      data.chip[name] = []
    })
    .finally(() => {

    })
  }
  // 查询非海尔 二级物料供应商/二级物料 列表
  const getL2ListOf = (name) => {
    let url = ''
    if(name === 'Level2MaterialsList'){
      url = '/base/ecosphere/noSecondMaterialList'
    }else if(name === 'Level2SupplierList'){
      url = '/base/ecosphere/noSecondMaterialSupplyList'
    }
    proxy.$http({
      url: url,
      method: 'post',
      data:{
        supplyCode: props.getData.supplyCode,
        pageSize: 9999,
        pageNo: 1,
        searchFlag:	"sqm",
        fixConfig: true
      }
    })
    .then(res => {
      if (res.data.code === '200') {
        data.chip[name]= res.data.data.records
        if(postData.haierMaterialPicking === '0'){
          if(name === 'Level2MaterialsList'){
            data.chip[name].push({secondMtlNo:'empty',secondMtlName:'无'})
          }else if(name === 'Level2SupplierList'){
            data.chip[name].push({secondSupplyCode:'empty',secondSupplyName:'无'})
          }
        }
      } else {
        proxy.warning(res.data.msg)
      }
    })
    .catch(err => {
      data.chip[name] = []
    })
    .finally(() => {

    })
  }
  // 二级物料商 change 选名称
  const level2SupplyChange = (v) =>{
    if(v){
      postData.secondSupplyName = data.chip.Level2SupplierList.find(item => item.secondSupplyCode == v)?.secondSupplyName
    }else{
      postData.secondSupplyCode = null
    }
  }
  // 二级物料 change 选名称
  const level2MtlChange = (v) => {
    if(v){
      postData.secondMtlName = data.chip.Level2MaterialsList.find(item => item.secondMtlNo == v)?.secondMtlName
    }else{
      postData.secondMtlNo = null
    }
  }
  // 是否海尔领料 change 事件， 
  const isHaierPickingChange = (v) => {
    data.chip['Level2MaterialsList'] = []
    data.chip['Level2SupplierList'] = []
    if(v && v === '1'){
      // 是否海尔领料=是，查找【采购二级物料】信息中的数据；
      getL2ListOfHaier('Level2MaterialsList')
      // 是否海尔领料=是，查找【采购二级物料商】信息中的启用的数据；
      getL2ListOfHaier('Level2SupplierList')
    }else if(v === '0'){
      // 是否海尔领料=否，查询质量自建的【非海尔领料二级物料】；可下拉无选择项，可通过【新增】按钮添加
      // 是否海尔领料=否，查询质量自建的【非海尔领料二级物料商】；可下拉无选择项，可通过【新增】按钮添加
      getL2ListOf('Level2MaterialsList')
      getL2ListOf('Level2SupplierList')
    }
    // 清空二级数据
    postData.secondMtlNo = null
    postData.secondMtlName = null
    postData.secondSupplyCode = null
    postData.secondSupplyName = null
  }

  /**
 * 勾选操作
 * @param {*} rowArr 选中行
 */
const listCheckBoxChange = (rowArr) => {
  data.clickRowList = rowArr
};
  // 返回
  const routerBack = () => {
    emit('routerBack')
  }
  // 暂存 sqm
  const save = () =>{
    postData.defectPhotoUuid = data.fileUploadToOss.map(v => v.filePath).join(",")
    postData.defectPhotoName = data.fileUploadToOss.map(v => v.fileName).join(",")
    emit('save',postData)
  }
  // 提交 sqm
  const submit = () => {
    // 空校验
    postData.defectPhotoUuid = data.fileUploadToOss.map(v => v.filePath).join(",")
    postData.defectPhotoName = data.fileUploadToOss.map(v => v.fileName).join(",")
    // 供应商补充OID：生态圈=电脑板 & 【EMR记录OID】为空时，必填
    if(props.getData.ecosphere === '电脑板' && !props.getData.oid && !postData.supplementOid){
      data.chip.supplyOIDText = h_i18n('33239986C13032CDE38FC5FFD148BD31')+h_i18n('281bada7259f6bcb836f62aa0b3e8f48')
      data.chip.supplyOIDFlag = true;
      data.btnLoading = true;
      setTimeout(() => {
        data.chip.supplyOIDFlag = false;
        data.btnLoading = false;
      }, 2000);
      return
    }
    if(props.getData.ecosphere === '电脑板' && !props.getData.oid && postData.supplementOid.length < 10){
      data.chip.supplyOIDText = h_i18n('33239986C13032CDE38FC5FFD148BD31')+h_i18n('512794ECECB2B14DDDAAE6B253BC8893')
      data.chip.supplyOIDFlag = true;
      data.btnLoading = true;
      setTimeout(() => {
        data.chip.supplyOIDFlag = false;
        data.btnLoading = false;
      }, 2000);
      return
    }
    // 不良分析结果
    if (!postData.analysisConclusion) {
      data.analysisConclusionFlag = true;
      data.btnLoading = true;
      setTimeout(() => {
        data.analysisConclusionFlag = false;
        data.btnLoading = false;
      }, 2000);
      return;
    }
    // 缺陷类别1级
    if (!postData.defectType) {
      data.defectTypeFlag = true;
      data.btnLoading = true;
      setTimeout(() => {
        data.defectTypeFlag = false;
        data.btnLoading = false;
      }, 2000);
      return;
    }
    // 缺陷类别2级
    if (data.showSecond && !postData.secondDefectType) {
      data.secondDefectTypeFlag = true;
      data.btnLoading = true;
      setTimeout(() => {
        data.secondDefectTypeFlag = false;
        data.btnLoading = false;
      }, 2000);
      return;
    }
    // 是否芯片类缺陷
    if(postData.chip === null || postData.chip === undefined){
      data.chip.chipDefectFlag = true;
      data.btnLoading = true;
      setTimeout(() => {
        data.chip.chipDefectFlag = false;
        data.btnLoading = false;
      }, 2000);
      return;
    }
    // 是否芯片类为Y，校验 是否海尔领料 二级物料商 二级物料 二级物料生产批次
    if (postData.chip === '1') {
      console.log('postData.haierMaterialPicking',postData.haierMaterialPicking)
      if(postData.haierMaterialPicking === null || postData.haierMaterialPicking === undefined || postData.haierMaterialPicking === ''){
        data.chip.isHaierPickingFlag = true
        data.btnLoading = true;
        setTimeout(() => {
          data.chip.isHaierPickingFlag = false;
          data.btnLoading = false;
        }, 2000);
        return
      }
      if(!postData.secondSupplyCode){ // 二级物料商
        data.chip.Level2SupplierFlag = true;
        data.btnLoading = true;
        setTimeout(() => {
          data.chip.Level2SupplierFlag = false;
          data.btnLoading = false;
        }, 2000);
        return
      }
      if(!postData.secondMtlNo){ // 二级物料
        data.chip.Level2MaterialsFlag = true;
        data.btnLoading = true;
        setTimeout(() => {
          data.chip.Level2MaterialsFlag = false
          data.btnLoading = false;
        }, 2000);
        return
      }
      // 二级物料生产批次
      if(!postData.secondSupplyBatch){
        data.chip.Level2MaterialProductionBatchFlag = true;
        data.btnLoading = true;
        setTimeout(() => {
          data.chip.Level2MaterialProductionBatchFlag = false;
          data.btnLoading = false;
        }, 2000);
        return;
      }
    }
    if (!postData.supplyDutyNode) {
      data.supplyDutyNodeFlag = true;
      data.btnLoading = true;
      setTimeout(() => {
        data.supplyDutyNodeFlag = false;
        data.btnLoading = false;
      }, 2000);
      return;
    }
    if (!postData.defectPhotoUuid) {
      data.defectPhotoUuidFlag = true;
      data.btnLoading = true;
      setTimeout(() => {
        data.defectPhotoUuidFlag = false;
        data.btnLoading = false;
      }, 2000);
      return;
    }
    if (!postData.improvedState) {
      data.improvedStateFlag = true;
      data.btnLoading = true;
      setTimeout(() => {
        data.improvedStateFlag = false;
        data.btnLoading = false;
      }, 2000);
      return;
    }
    emit('submitSave',postData)
  }
  // 审核通过 hmqm
  const submitPass = () => {
    if(!postData.sqeAuditMessage){
      proxy.info(h_i18n('10798223367749984eb5a5665b3fcbc9'))
      return
    }
    emit('submitPass',postData)
  }
  // 审核驳回 hmqm
  const submitOverrule = () => {
    if(!postData.sqeAuditMessage){
      proxy.info(h_i18n('10798223367749984eb5a5665b3fcbc9'))
      return
    }
    emit('submitOverrule',postData)
  }
  // 下载缺陷照片
  const openDefectPhoto = (url) => {
    window.open(url)
  }
  // 借用机编 的 分析详情
  const openBorrowProductNum = () => {
    if(!data.borrowId && !props.getData.borrowId){
      return
    }
    proxy.$router.push({
      name:'DefectiveProductAnalysisEcoDetail',
      query: {
        id: data.borrowId || props.getData.borrowId,
        supplyCode: props.getData.supplyCode,
        supplyName: props.getData.supplyName,
        dataFrom: route.query.dataFrom,
        kindType: route.query.dataFrom == 'sqm' ? 'detail' : 'particulars'
      }
    })
  }
  // 删除 借用的机编
  const deleteBorrowProductBtn = () => {
    postData.borrowProductNum = undefined
    // 清除借用的数据
    postData.analysisConclusion = undefined
    postData.defectType = undefined
    postData.supplyDutyNode = undefined
    postData.improvedState = undefined
    // postData.chip = undefined
    // postData.secondMtlName = undefined
    // postData.secondMtlNo = undefined
    // postData.supplyName = undefined
    // postData.secondSupplyCode = undefined
    // postData.haierMaterialPicking = undefined
    // postData.secondSupplyBatch = undefined
    clearChipDefect()
  }
  // 清空芯片缺陷类内容
  const clearChipDefect = () => { 
    postData.chip = undefined
    postData.secondMtlName = undefined
    postData.secondMtlNo = undefined
    postData.supplyName = undefined
    postData.secondSupplyCode = undefined
    postData.secondSupplyName = undefined
    postData.haierMaterialPicking = undefined
    postData.secondSupplyBatch = undefined
  }
  // 查询机编  同工厂+同物料+同故障码，近1年已经分析完成并且非借用分析的不良品数据
  const searchBorrowProductNum = () => {
    data.borrowloading = true
    proxy.$http({
      // url:'/base/emr/borrowReport',
      url:'/base/emr/listPage',
      method:'post',
      data:{
        ...searchData,
        phenomenaCode:props.getData.phenomenaCode, // 故障码
        mtlNo:props.getData.mtlNo, // 专用号
        sybId:props.getData.sybId, // 工厂小微
        supplyCode:props.getData.supplyCode,
        searchFlag: 'supply'
      }
    }).then(res=>{
      if (res.data.code === "200") {
        data.borrowDataList = res.data.data.records;

        data.total = res.data.data.total;
        data.borrowloading = false;
      } else {
        proxy.warning({ message: res.data.msg, title: h_i18n('acd5cb847a4aff235c9a01ddeb6f9770') });
        data.borrowloading = false;
      }
    }).catch(err=>{

    }).finally(()=>{
      
    })
  }
  // 借用机编
  const borrowProductBtn = () => {
    data.showBorrowProductNum = true
    searchBorrowProductNum()
  }
  // 借用操作
  const borrowBtn = () => {
    if(!data.clickRowList || data.clickRowList.length != 1){
      proxy.info(h_i18n('426ccea7fe7f595f80740f71042b330f'))
      return
    }
    // 填写借用的数据
    postData.borrowProductNum = data.clickRowList[0].productNum
    postData.analysisConclusion = data.clickRowList[0].analysisConclusion
    postData.defectType = data.clickRowList[0].defectType
    postData.secondDefectType = data.clickRowList[0].secondDefectType
    postData.supplyDutyNode = data.clickRowList[0].supplyDutyNode
    postData.improvedState = data.clickRowList[0].improvedState
    data.borrowId = data.clickRowList[0].id
    postData.ifBrorrow = 1
    // 芯片&OID码需求 新增字段接入借用数据
    postData.chip = data.clickRowList[0].chip || null
    postData.secondMtlName = data.clickRowList[0].secondMtlName || null
    postData.secondMtlNo = data.clickRowList[0].secondMtlNo || null
    postData.supplyName = data.clickRowList[0].supplyName || null
    postData.secondSupplyCode = data.clickRowList[0].secondSupplyCode || null
    postData.haierMaterialPicking = data.clickRowList[0].haierMaterialPicking || null
    postData.secondSupplyBatch = data.clickRowList[0].secondSupplyBatch || null
    // data.clickRowList[0].chip && (postData.chip = data.clickRowList[0].chip) // 是否芯片缺陷类
    // data.clickRowList[0].secondMtlName && (postData.secondMtlName = data.clickRowList[0].secondMtlName)
    // data.clickRowList[0].secondMtlNo && (postData.secondMtlNo = data.clickRowList[0].secondMtlNo)
    // data.clickRowList[0].secondSupplyCode && (postData.secondSupplyCode = data.clickRowList[0].secondSupplyCode)
    // data.clickRowList[0].supplyName && (postData.supplyName = data.clickRowList[0].supplyName)
    closeborrowProductDialog()
  }
  // 关闭借用
  const closeborrowProductDialog = () => {
    data.showBorrowProductNum = false
    data.clickRowList = []
  }
  // 多个文件上传下载
  /**
   * 文件上传弹出面板
   */
  const openUpFileDialogShow = () => {
    data.fileAddArr = []
    data.fileAddArr = data.fileUploadToOss.map((v, i) => ({...v, status: "success", progress: 100, name: v.fileName})).filter(v => v.fileName)
    data.upFileDialogShow = true
  }
  /**
   * 删除文件
   */
  const removeFile = (file) => {
    data.fileAddArr = data.fileAddArr.filter(v => v.uid !== file.uid)
  }
  /**
   * 选择文件
   */
  const chooseFile = (file, fileList) => {
    // 重复禁止上传
    let sIndex = fileList.map((item)=>{
      return item.name
    }).indexOf(file.name)
    let eIndex = fileList.map((item)=>{
      return item.name
    }).lastIndexOf(file.name)
    if(sIndex == eIndex){
      data.fileAddArr = fileList
    }else{
      proxy.info(h_i18n('8aeefba376ab3d2fdbef6567bc8df98c'))
      fileList.pop()
      data.fileAddArr = fileList
    }
  }
  // 上传错误
  const errorFile = (str) => {
    proxy.info(str)
  }
  // 上传 
  const uploadFile = () =>{
    if(data.fileAddArr.length < 1){
      proxy.info(h_i18n('260b4ddd897e5fd7086ea0e78f67f790'))
      return
    }
    
    let uploadFileList = data.fileAddArr.filter(v => v.status === "default")
      if (uploadFileList.length === 0) {
        if (data.fileUploadToOss.length !== data.fileAddArr.length) {
          data.fileUploadToOss = data.fileAddArr.map(v => ({fileName: v.name, filePath: v.filePath}))
          data.upFileDialogShow = false
          return false
        }
        proxy.info(h_i18n('9febf31146d9c96bfde09a4a20dcf17d'))
        return false
      }
      let formData = new FormData()
      uploadFileList.map(v => {
        formData.append('files', v.file)
        v.progress = 50
      })      
      return proxy.$http({
        method: 'post',
        url: '/base/fileUpload/uploadToOssSaveUrl',
        headers: {'Content-Type': 'multipart/form-data'},
        data: formData,
        cache: false,
        processData: false,
        contentType: false,
      }).then((res) => {
        if (res.data.code === "0") {
          let resData = res.data.data
          
          let noList = data.fileAddArr.filter(v => !v.filePath)
          let hasList = data.fileAddArr.filter(v => v.filePath)
          data.fileUploadToOss = [...hasList.map(v => {
            return {
              fileName: v.name,
              filePath: v.filePath
            }

          }), ...resData.split(",").map((v, i) => {
            return {
              fileName: noList[i] ? noList[i].name : `computer${proxy.time()}`,
              filePath: v
            }
          })]
          
          uploadFileList.map(v => {
            v.progress = 100
            v.status = "success"
          })

        proxy.success({message:h_i18n('a7699ba73144aad544eb9ac49f82749d'), title:h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'),
          confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
          cancelButtonText: h_i18n('625fb26b4b3340f7872b411f401e754c'),
          callback: action => {
            data.upFileDialogShow = false
          }
        })

        } else {
          return Promise.reject()
        }
      }).catch((err) => {
        uploadFileList.map(v => {
          v.progress = 100
          v.status = "fail"
        })
        proxy.error(h_i18n('54e5de428ca9d59119d4624706215a4d'),err)
      });
    
  }
  // 多个文件结束
  // 单个文件上传下载

  /**
 * 错误提示
 */
//  const errorFile = (str) => {
//   proxy.warning({title: '提示', message: str})
// }
/**
 * h-file-upload 上传文件
 */
const fileChange = (file,f) => {
    postData.replenishName = file.name
    let formData = new FormData()
    formData.append('files', file.file)
    proxy.startLoading(h_i18n('92cd554eff7896f979917f3ae449b460'))
    proxy.$http({
      method: "POST",
      url: "/base/fileUpload/uploadToOssSaveUrl",
      data: formData
    }).then(res => {
      if (res.data.code === "0") {
        postData.replenishUuid = res.data.data
      } else {
        proxy.error(h_i18n('3a845c4dd82bd5a445333dfcbabb4350'))
        data.fileTemp = null
      }
    }).catch(err=>{

    }).finally(()=>{
      proxy.closeLoading()
    })
  
}
/**
 * h-file-upload 下载
 */
const download = () =>{
    proxy.startLoading(h_i18n('29f986479f7cf1f93d31172f343d4521'))
    proxy.httpFile({
      method: "get",
      url: "/tosqmfordown/"+postData.replenishUuid.split('https://sqm.haier.net/')[1],
      headers: {'content-type': 'application/json'},
    }, postData.replenishName)
}

/**
 * h-file-upload 删除
 */
const deleteFun = () =>{
    postData.replenishUuid = ''
    postData.replenishName = ''
    data.fileTemp = {}  
}
// 单个文件结束
// 获取 缺陷类别一级
const getDefectTypeList = () => {
  proxy.$http({
    url: '/base/ecosphere/ecosphereDefectTypeOneList',
    method: 'post',
    data: {
      pageNo:1,
      pageSize:9999,
      sqeNode:props.getData.sqeNode,
      ecosphere:props.getData.ecosphere
    }
  })
  .then(res => {
    if (res.data.code == 200) {
      data.defectTypeList = res.data.data.records
      if(data.defectTypeList.some(item=>{
      return item.level == 2
    })){
      data.showSecond = true
    }else{
      data.showSecond = false
    }
    // data.defectTypeList.unshift({defectType:'其他'})
    } else {
      proxy.info(res.data.data)
      data.defectTypeList = []
      data.showSecond = false
    }
  })
  .catch(err => {
    data.defectTypeList = []
    data.showSecond = false
  })
  .finally(() => {

  })
}
  // 获取 缺陷类别 （ 查二级）
const getSecondDefectTypeList = flag => {
  proxy.$http({
    url: '/base/ecosphere/ecosphereDefectTypeList',
    method: 'post',
    data: {
      pageNo:1,
      pageSize:9999,
      fixConfig:true,
      defectType:postData.defectType,
      sqeNode:props.getData.sqeNode,
      ecosphere:props.getData.ecosphere,
    }
  })
  .then(res => {
    if (res.data.code == 200) {
      data.secondDefectTypeList = res.data.data.records
      // 第一次调用此接口不用查询chip
      if(flag === 'one')return
      // 没有二级时，芯片类的逻辑
      if(!data.showSecond){
        // 如果子项chip都为0 非芯片类
        if(data.secondDefectTypeList.some(item => item.chip === '1')){
          if(postData.chip != '1'){
            postData.secondSupplyBatch = null
            postData.secondMtlNo = null
            postData.secondMtlName = null
            postData.secondSupplyCode = null
            postData.secondSupplyName = null
            postData.haierMaterialPicking = null
          }
          postData.chip = '1'
        } else {
          if(postData.chip != '0'){
            postData.secondSupplyBatch = null
            postData.secondMtlNo = null
            postData.secondMtlName = null
            postData.secondSupplyCode = null
            postData.secondSupplyName = null
            postData.haierMaterialPicking = null
          }
          postData.chip = '0'
        }
      }
      // data.secondDefectTypeList.unshift({secondDefectType:'其他'})
    } else {
      proxy.info(res.data.data)
      data.secondDefectTypeList = []
    }
  })
  .catch(err => {
    data.secondDefectTypeList = []
  })
  .finally(() => {

  })
}
// 缺陷类别1级 选择
const changeDefectType = (v) =>{
  if(v){
    data.secondDefectTypeList = []
    postData.secondDefectType = undefined
    clearChipDefect()
    getSecondDefectTypeList()
  }else{
    data.secondDefectTypeList = []
    postData.secondDefectType = undefined
    postData.defectType = undefined
    //清理芯片数据
    clearChipDefect()
  }
}
// 缺陷类别2级 选择
const changeSecondDefectType = (v) => {
  if(v){
    // 查询是否芯片类缺陷
    clearChipDefect()
    postData.chip = data.secondDefectTypeList.find(item => item.secondDefectType === v)?.chip
    // if(postData.chip === '1'){
    //   // 是芯片类缺陷 打开后面四个选项【是否海尔领料】【二级物料商】【二级物料】【二级物料生产批次】
    // }else{
    //   // 如果有选过后面四个选项【是否海尔领料】【二级物料商】【二级物料】【二级物料生产批次】，清除
    //   // postData.haierMaterialPicking = null
    //   // postData.secondSupplyCode = null
    //   // postData.secondSupplyName = null
    //   // postData.secondMtlNo = null
    //   // postData.secondMtlName = null
    //   // postData.secondSupplyBatch = null
    // }
  }else{
    postData.secondDefectType = undefined
    //清理芯片数据
    clearChipDefect()
    // postData.chip = null
    // postData.haierMaterialPicking = null
    // postData.secondSupplyCode = null
    // postData.secondSupplyName = null
    // postData.secondMtlNo = null
    // postData.secondMtlName = null
    // postData.secondSupplyBatch = null
  }
}
const getOldInfo = () => {
  postData.analysisActualDate = new Date()
  postData.supplyTrueName = route.query.trueName || route.query.userName
  // 暂存的数据 回显
  postData.borrowProductNum = props.getData.borrowProductNum
  postData.analysisConclusion = props.getData.analysisConclusion
  postData.defectType = props.getData.defectType
  if(props.getData.secondDefectType){
    getSecondDefectTypeList()
    postData.secondDefectType = props.getData.secondDefectType
  }
  postData.supplyDutyNode = props.getData.supplyDutyNode
  postData.defectPhotoUuid = props.getData.defectPhotoUuid
  postData.defectPhotoName = props.getData.defectPhotoName
  console.log('chip/haierMaterialPicking---------->',props.getData.chip,props.getData.haierMaterialPicking)
  postData.chip = props.getData.chip || null
  postData.haierMaterialPicking = props.getData.haierMaterialPicking || null
  if(postData.chip === '1'){
    console.log('haierMaterialPicking---------->',postData.haierMaterialPicking)
    if(postData.haierMaterialPicking === '1'){
      getL2ListOfHaier('Level2SupplierList')
      getL2ListOfHaier('Level2MaterialsList')
    }else if(postData.haierMaterialPicking === '0'){ 
      getL2ListOf("Level2MaterialsList")
      getL2ListOf("Level2SupplierList")
    }
  }
  postData.secondSupplyBatch = props.getData.secondSupplyBatch || null
  postData.secondMtlNo = props.getData.secondMtlNo || null
  postData.secondMtlName = props.getData.secondMtlName || null
  postData.secondSupplyCode = props.getData.secondSupplyCode || null
  postData.secondSupplyName = props.getData.secondSupplyName || null
  postData.supplementOid = props.getData.supplementOid || null
  
  let u = ''
  let n = ''
  let fileTempArr = []
  if(postData.defectPhotoUuid && postData.defectPhotoName){
    u = postData.defectPhotoUuid.split(',')
    n = postData.defectPhotoName.split(',')
    fileTempArr = n.map((item,index)=>{
      return {fileName:item,filePath:u[index]}
    })
  }
  if(fileTempArr.length > 0){
    data.fileUploadToOss = fileTempArr.map((v, i) => ({...v, status: "success", progress: 100, name: v.fileName})).filter(v => v.fileName)
  }
  postData.improvedState = props.getData.improvedState
  postData.replenishName = props.getData.replenishName
  postData.replenishUuid = props.getData.replenishUuid
  data.fileTemp = {name:postData.replenishName}
  // 回显结束
}
  onMounted(() => {
    props.kindType == 'detail' && (data.title = h_i18n('f26225bde6a250894a04db4c53ea03d0'))
    props.kindType == 'save' && (data.title = h_i18n('939d5345ad4345dbaabe14798f6ac0f1'))
    props.kindType == 'particulars' && (data.title = h_i18n('f26225bde6a250894a04db4c53ea03d0'))
    props.kindType == 'audit' && (data.title = h_i18n('cf13b1a67881f454af469aa874f087e5'))
    if(props.kindType == 'save'){
      if(props.getData.sqeAuditConclusion == 'F'){
        data.titleList =  [h_i18n('eba745696b4f04640b0b00ebd4d7309f'),h_i18n('acda736d85c260c17b9bbf0ccaf9278b')]
        getDefectTypeList()
        getSecondDefectTypeList('one')
        getOldInfo()
        data.reType = true
        postData.borrowProductNum = props.getData.borrowProductNum
      }else 
      if(props.getData.sqeAuditConclusion == 'P'){
        proxy.info({title:h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'),message:h_i18n('bdebd0fea7bddf84223d703a54b502e3'),confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),callback:()=>{
          data.titleList =  [h_i18n('eba745696b4f04640b0b00ebd4d7309f'),h_i18n('acda736d85c260c17b9bbf0ccaf9278b')]
          proxy.$router.push({
            name:'DefectiveProductAnalysisEcoDetail',
            query: {
              id: props.getData.id,
              supplyCode: props.getData.supplyCode,
              supplyName: props.getData.supplyName,
              dataFrom: 'sqm',
              kindType:'detail'
            }
          })
        }})
      }else
      {
        getDefectTypeList()
        getSecondDefectTypeList('one')
        if(props.getData.analysisStatus == '暂存'){
          getOldInfo()
          data.secondType = true
        }else{
          postData.analysisActualDate = new Date()
          postData.supplyTrueName = route.query.userName || route.query.trueName 
          data.firstType = true
        }
        data.titleList =  [h_i18n('eba745696b4f04640b0b00ebd4d7309f')]
      }
    }else{
      data.titleList =  [h_i18n('eba745696b4f04640b0b00ebd4d7309f'),h_i18n('acda736d85c260c17b9bbf0ccaf9278b')]
    }
  })
</script>

<style lang="scss">
  .td-input-style{
    .el-textarea__inner{
      height: 100%;
    }
  }
  .dialog_style .haier-dialog {
      top: 1%;
      .el-table{
        border-right: 0px !important;
    border-bottom: 0px !important;
      }
    }
  .dialog_list_style{
    min-width:-webkit-fill-available;
  }
  .addl2dialog{
    .addl2row{
      font-size:14px;
      .addl2col_b{
        margin:-8px 0 12px;
        height: 34px;
        display: flex;
      }
      .addl2col_s{
        margin-bottom:12px;
        display: flex;
        .el-input{
          width: 352px;
        }
      }
      .add2col_n{
        color: red;
      }
      .addl2title{
        width: 150px;
        .addl2required{
          padding-left: 8px;
          color: red;
        }
      }
    }
  }
</style>